import React, { useState, useRef } from 'react';
import { Overlay, Popover, Spinner, Button } from 'react-bootstrap';
import './ColorComponent.css'; // Gunakan CSS yang sama dari jawaban sebelumnya

/**
 * Props untuk ColorComponent.
 */
interface ColorComponentProps {
    // Warna awal yang tersimpan.
    color: string;

    // Callback yang dipanggil saat tombol "Save" diklik.
    onColorUpdate: (newColor: string) => void;

    // Status untuk menampilkan spinner loading.
    isUpdating: boolean;
}

export const ColorComponent: React.FC<ColorComponentProps> = ({
    color,
    onColorUpdate,
    isUpdating
}) => {
    // State untuk mengontrol visibilitas popover.
    const [showPopover, setShowPopover] = useState(false);

    // State untuk menyimpan warna pilihan pengguna sebelum disimpan (draft).
    const [draftColor, setDraftColor] = useState(color);

    // Ref untuk elemen yang menjadi target (pemicu) popover.
    const targetRef = useRef(null);

    // Handler saat swatch warna diklik untuk membuka popover.
    const handleToggle = () => {
        if (!showPopover) {
            setDraftColor(color);
        }
        setShowPopover(!showPopover);
    };

    // Handler saat tombol "Save" diklik.
    const handleSave = () => {
        if (draftColor !== color) {
            onColorUpdate(draftColor);
        }
        setShowPopover(false);
    };

    // Handler saat tombol "Cancel" diklik.
    const handleCancel = () => {
        setShowPopover(false);
    };

    return (
        <>
            {/* Ini adalah elemen pemicu (swatch warna) */}
            <div
                ref={targetRef}
                className="color-swatch"
                style={{ backgroundColor: color }}
                title="Click to change color"
                onClick={handleToggle}
            >
                {isUpdating && <Spinner animation="border" size="sm" variant="light" />}
            </div>

            {/* Komponen Overlay yang dikontrol oleh state 'showPopover' */}
            <Overlay
                show={showPopover}
                target={targetRef.current}
                placement="right"
                rootClose
                onHide={handleCancel}
            >
                {(props) => (
                    <Popover
                        id={`popover-color-${color}`}
                        className="color-popover"
                        {...props}
                    >
                        <Popover.Header as="h3">Change Color</Popover.Header>
                        <Popover.Body>
                            <input
                                type="color"
                                className="form-control form-control-color"
                                value={draftColor}
                                onChange={(e) => setDraftColor(e.target.value)}
                            />
                        </Popover.Body>

                        {/* 
                          DIUBAH DI SINI:
                          Mengganti Popover.Footer yang tidak ada dengan <div> biasa.
                          Kelas-kelas ini meniru tampilan footer.
                        */}
                        <div className="d-flex justify-content-end gap-2 p-2 border-top">
                            <Button variant="secondary" size="sm" onClick={handleCancel}>
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                size="sm"
                                onClick={handleSave}
                                disabled={isUpdating}
                            >
                                {isUpdating ? 'Saving...' : 'Save'}
                            </Button>
                        </div>
                    </Popover>
                )}
            </Overlay>
        </>
    );
};